export function autoSizeAllColumns() {
	let allColumnIds = [];
	window.gridSettings.columnApi.getColumns().forEach(function (column) {
		allColumnIds.push(column.colId);
	});
	window.gridSettings.columnApi.autoSizeColumns(allColumnIds);
}
